import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

type ConnectionTone = 'success' | 'warning' | 'neutral';

type ConnectionStatusChipProps = {
  tone: ConnectionTone;
  children: ReactNode;
  className?: string;
};

// 칩은 반드시 bg + fg 페어로 쓴다(디자인 시스템). daisyUI content 클래스는 다크에서 글자가 새므로 금지.
const toneStyle: Record<ConnectionTone, { background: string; color: string }> = {
  success: { background: 'var(--chip-success-bg)', color: 'var(--chip-success-fg)' },
  warning: { background: 'var(--chip-warning-bg)', color: 'var(--chip-warning-fg)' },
  neutral: { background: 'var(--chip-neutral-bg)', color: 'var(--chip-neutral-fg)' },
};

/**
 * 연결 상태(연결됨 / 연결 필요 / 미연결) 칩.
 *
 * 통합 화면은 같은 상태를 추가 패널·목록 행·섹션 헤더 세 군데에서 보여준다.
 * 각자 칩을 그리면 크기와 색이 조금씩 갈라지므로 한 컴포넌트로 고정한다.
 */
export const ConnectionStatusChip = ({ tone, children, className }: ConnectionStatusChipProps) => (
  <span className={cn('rounded-full px-2 py-0.5 text-[10px] font-medium', className)} style={toneStyle[tone]}>
    {children}
  </span>
);

export default ConnectionStatusChip;
